<template>
   <div class="mdmemo-container" v-if="isMounted">
    <BaseInputWithContextMenu
      :target-id="inputElementId"
      :is-read-only="isReadOnlyState"
      :value="value"
      :enable-speech-features="true"
      :enable-system-options="true"
      @input="onInput"
      @control-changed="setChangedStatus"
      :control-id="Name"
    >
      <div v-if="VisibleLabel" class="textlabel" :data-label="Label"></div>
      <div class="mdmemo-textarea-wrapper">
        <b-form-textarea
            class="MdMemo"
            :class="UseDinamicClass ? 'cutescroll '+DynamicClass : 'cutescroll'"
            :id="inputElementId"
            :name="Name"
            :rows="Rows"
            :autofocus="isAutoFocus"
            :max-rows="MaxRows"
            :maxlength="MaxLength"
            :disabled=this.isReadOnly
            :placeholder="Placeholder"
            v-bind:value="value"
            v-on:change="OnChange"
            v-on:input="onInput"
            v-bind:style="style"
        ></b-form-textarea>
        <button
          v-if="!isReadOnly && $store.state.useAIAssist"
          class="ai-write-btn"
          type="button"
          :title="$t('AiWriter.HelpMeWrite')"
          @click="openAiWriter"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#19BEE8" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5Z"/>
            <path d="M19 15l.75 2.25L22 18l-2.25.75L19 21l-.75-2.25L16 18l2.25-.75Z"/>
            <path d="M5 3l.5 1.5L7 5l-1.5.5L5 7l-.5-1.5L3 5l1.5-.5Z"/>
          </svg>
        </button>
      </div>
    </BaseInputWithContextMenu>

    <b-modal
      v-model="showAiPanel"
      id="ai-writer-modal"
      :title="$t('AiWriter.Title')"
      hide-footer
      size="md"
      @shown="makeAiModalDraggable"
      @hidden="resetAiPanel"
    >
      <div class="ai-writer-body">
        <label class="ai-label">{{ $t('AiWriter.WhatToWrite') }}</label>
        <b-form-textarea
          ref="aiInstructionInput"
          v-model="aiInstruction"
          :placeholder="$t('AiWriter.Placeholder')"
          rows="3"
          class="ai-instruction-input"
          :disabled="isGenerating"
        ></b-form-textarea>

        <div class="mt-2 d-flex justify-content-end">
          <b-button
            variant="primary"
            size="sm"
            :disabled="isGenerating || !aiInstruction.trim()"
            @click="generateText"
          >
            <span v-if="isGenerating">{{ $t('AiWriter.Generating') }}</span>
            <span v-else>{{ $t('AiWriter.Generate') }}</span>
          </b-button>
        </div>

        <div v-if="aiError" class="mt-2 text-danger small">{{ aiError }}</div>

        <div v-if="aiGeneratedText" class="ai-preview mt-3">
          <label class="ai-label">{{ $t('AiWriter.GeneratedText') }}</label>
          <b-form-textarea
            v-model="aiGeneratedText"
            class="ai-preview-text"
            rows="5"
            max-rows="10"
          ></b-form-textarea>
          <div class="mt-2 d-flex justify-content-end">
            <b-button variant="primary"           size="sm" class="mr-1" @click="insertText">{{ $t('AiWriter.Insert') }}</b-button>
            <b-button variant="outline-primary"   size="sm" class="mr-1" @click="replaceText">{{ $t('AiWriter.Replace') }}</b-button>
            <b-button variant="outline-primary"   size="sm" class="mr-1" :disabled="isGenerating" @click="generateText">{{ $t('AiWriter.Regenerate') }}</b-button>
            <b-button variant="outline-secondary" size="sm" @click="closeAiWriter">{{ $t('AiWriter.Discard') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { EventBus } from '@/event-bus.js';
  import Vue from 'vue';
  import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
  import ApiService from '@/services/api.service';

  Vue.use(ContextMenuPlugin);
  export default {
    name: 'MdMemo',
   props: {     
     MaxRows: String,
     Rows: String,
     MaxLength: String,
     Label:String,
     isReadOnly:Boolean,
     value:[String, Number],
     Name:String,
     Placeholder:String,
     Tag: String,
     isRequired: Boolean,
     isValid:Boolean,
     UseDinamicClass:Boolean,
     DynamicClass:String,
     VisibleLabel:Boolean,
     OnAuxFunc:Function,
     IsAux:Boolean,
     NoValidateChanges:Boolean,
     IdButton:String,
     isAutoFocus:Boolean,
     Obj1:Object
   },
    watch: {
      isValid: function (newValue) {
        this.setValid(newValue)
      }
    },
    data() {
      return {
        style: {
          border: 'solid 1px #e0e0e0 !important',
          borderColor: '#e0e0e0 !important',
          padding: '5px'
        },
        Invalid: false,
        menuItems:[],
        isMounted: false,
        // AI Writer
        showAiPanel: false,
        aiInstruction: '',
        aiGeneratedText: '',
        aiError: '',
        isGenerating: false
      }
    },
    computed: {
      inputElementId() {
        return this.Name;
      },
      
      isReadOnlyState() {
        return  this.isReadOnly;
      }
    },
    methods:{
      OnChange(value){
        this.$emit('input',value)
      },

      onInput(evt){
        const val = evt && evt.target ? evt.target.value : evt;
        this.setChangedStatus(val);
        this.Invalid = val.length == 0 && this.isRequired ? true : false;
        this.style.borderColor = this.Invalid ? '#dc3545 !important' : '#e0e0e0 !important';
        if (this.IsAux && typeof this.OnAuxFunc === 'function') {
          this.OnAuxFunc();
        }
        // sync with external v-model
        this.$emit('input', val);
      },

      setValid(state) {
        this.style.borderColor = state ? '#e0e0e0 !important' : '#dc3545 !important'
      },

      setRequired(value) {
        this.isRequired = value;
        if (!value) {
          this.style.borderColor = '#e0e0e0 !important';
        }
      },

      setChangedStatus( sp ){
        this.$emit('input', sp)
        var changed = {
          "Changed":true,
          "ComponentName":this.Name,
          "Tag": this.Tag,
          "IdButton":this.IdButton,
          "Obj1":this.Obj1,
          "Value" : sp 
        }
        if(!this.NoValidateChanges){
          EventBus.$emit('onChanged', changed);
        } 
      },

      updateValue(newValue) {
        this.$emit('input', newValue);
      },

      getControlId() {
        return this.Name;
      },

      // 🔹 Lógica de Speech-to-Text
      setValueS2T(sp) {
        const sp2t = (this.value || '') + sp;
        this.$emit('input', sp2t);
        this.setChangedStatus(sp2t);
      },

      makeAiModalDraggable() {
        this.$nextTick(() => {
          const outer = document.getElementById('ai-writer-modal___BV_modal_outer_');
          const dialog = outer?.querySelector('.modal-dialog');
          const header = outer?.querySelector('.modal-header');
          if (!dialog || !header) return;
          header.style.cursor = 'move';
          let dragging = false, offsetX = 0, offsetY = 0;
          header.onmousedown = (e) => {
            e.preventDefault();
            const rect = dialog.getBoundingClientRect();
            offsetX = e.clientX - rect.left;
            offsetY = e.clientY - rect.top;
            dragging = true;
            dialog.style.position = 'fixed';
            dialog.style.margin = '0';
            dialog.style.transform = 'none';
            dialog.style.width = `${rect.width}px`;
            dialog.style.left = `${rect.left}px`;
            dialog.style.top = `${rect.top}px`;
          };
          document.onmousemove = (e) => {
            if (!dragging) return;
            dialog.style.left = `${e.clientX - offsetX}px`;
            dialog.style.top = `${e.clientY - offsetY}px`;
          };
          document.onmouseup = () => { dragging = false; };
          this.$refs.aiInstructionInput.focus();
        });
      },

      // AI Writer
      openAiWriter() {
        this.showAiPanel = true;
      },

      closeAiWriter() {
        this.showAiPanel = false;
      },

      resetAiPanel() {
        this.aiInstruction = '';
        this.aiGeneratedText = '';
        this.aiError = '';
        this.isGenerating = false;
      },

      async generateText() {
        if (!this.aiInstruction.trim()) return;
        this.isGenerating = true;
        this.aiError = '';
        this.aiGeneratedText = '';
        try {
          const payload = { instruction: this.aiInstruction };
          if (this.value) payload.existingText = this.value;
          const response = await ApiService.post('AiAssist', payload);
          this.aiGeneratedText = response.data.generatedText || '';
        } catch {
          this.aiError = this.$t('AiWriter.Error');
        } finally {
          this.isGenerating = false;
        }
      },

      insertText() {
        const updated = (this.value ? this.value + '\n' : '') + this.aiGeneratedText;
        this.$emit('input', updated);
        this.setChangedStatus(updated);
        this.closeAiWriter();
      },

      replaceText() {
        this.$emit('input', this.aiGeneratedText);
        this.setChangedStatus(this.aiGeneratedText);
        this.closeAiWriter();
      },
  },
  mounted(){
    this.$nextTick(() => {
      this.isMounted = true;
    });
  },
  created() {
      EventBus.$on("receivedS2T", function (event) {
        if( event.ControlId == this.Name) { 
            this.setValueS2T( event.finalSentence )
        }
      }.bind(this))
  }
}
</script>

<style scoped>
.mdmemo-textarea-wrapper {
  position: relative;
}

.ai-write-btn {
  position: absolute;
  top: 4px;
  right: 6px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  opacity: 1;
  transition: opacity 0.2s;
  z-index: 1;
}

.ai-write-btn:hover {
  opacity: 1;
  filter: brightness(1.2);
}

.ai-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
  display: block;
}

.ai-instruction-input {
  font-size: 13px;
}

.ai-preview {
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.ai-preview-text {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 13px;
  white-space: pre-wrap;
  max-height: 200px;
  overflow-y: auto;
}
</style>
